import { type PropertyGroup as PropertyGroupType } from "../hooks/usePropertyFiltering";
import { PropertyGroup } from "./PropertyGroup";

interface PropertyGroupListProps {
    groups: PropertyGroupType[];
    searchTerm: string;
    isSearchActive: boolean;
    isGroupExpanded: (groupName: string, isSearchActive: boolean) => boolean;
    getGroupStats: (groupName: string) => {
        selected: number;
        isFullySelected: boolean;
        isPartiallySelected: boolean;
    };
    isPropertySelected: (groupName: string, propertyName: string) => boolean;
    onToggleGroupExpansion: (groupName: string) => void;
    onToggleGroupSelection: (groupName: string) => void;
    onTogglePropertySelection: (groupName: string, propertyName: string, propertyValue: string) => void;
}

export function PropertyGroupList({
    groups,
    searchTerm,
    isSearchActive,
    isGroupExpanded,
    getGroupStats,
    isPropertySelected,
    onToggleGroupExpansion,
    onToggleGroupSelection,
    onTogglePropertySelection,
}: PropertyGroupListProps) {
    return (
        <>
            {groups.map((group) => {
                const { selected: selectedCount, isFullySelected, isPartiallySelected } = getGroupStats(group.name);
                const isExpanded = isGroupExpanded(group.name, isSearchActive);

                return (
                    <PropertyGroup
                        key={group.name}
                        group={group}
                        searchTerm={searchTerm}
                        isExpanded={isExpanded}
                        selectedCount={selectedCount}
                        isFullySelected={isFullySelected}
                        isPartiallySelected={isPartiallySelected}
                        isPropertySelected={isPropertySelected}
                        onToggleExpansion={() => onToggleGroupExpansion(group.name)}
                        onToggleGroupSelection={() => onToggleGroupSelection(group.name)}
                        onTogglePropertySelection={onTogglePropertySelection}
                    />
                );
            })}
        </>
    );
}
